import React, { memo, useState, useEffect, useCallback, useMemo } from 'react';
import FormGps from '../FormGps';
import ButtonMenu from '../../../shared/components/ButtonMenu';
import ListGpsDevicesToUpload from "./subComponents/ListGpsDevicesToUpload";
import CreateByBatch from '../CreateByBatch';
import { useTranslation } from 'react-i18next';
import { excelSVG, formSVG, unsubscribeSVG } from '../../../shared/helpers/icons';
import UnsubscribeByBatch from '../UnsubscribeByBatch';

const CreateGps = ({
    className,
    buttonClassName,
    submitGpsBatchRequest, 
    gps: {
        submitSuccess,
        submitFetching,
        submitValidateBatchFetching,
        submitValidateBatchSuccess,
        gpsBatchValidations,
        unsubscribeFetching,
        unsubscribeSuccess,
        errors
    },
    submitGpsDevicesValidateBatchRequest,
    setStateGps,
    clearValidatedGpsDevices,
    unsubscribeRequest,
    cleanUnsubscribe
}) => {
    const { t } = useTranslation(['home', 'devices']);

    const [isOpenFormDialog, setIsOpenFormDialog] = useState(false);
    const [isOpenBatchDialog, setIsOpenBatchDialog] = useState(false);
    const [isOpenUnsubscribeDialog, setIsOpenUnsubscribeDialog] = useState(false);
    const [showErrors, setShowErrors] = useState(false);

    const showGpsDevicesToLoad = useMemo(() =>
        Object.keys(gpsBatchValidations).length > 0
        && (gpsBatchValidations.available_to_insert.length > 0 || gpsBatchValidations.unavailable_to_insert.length > 0)
        , [gpsBatchValidations]);

    const handleFormDialog = () => {
        setIsOpenFormDialog(true);
    }

    const handleCloseFormDialog = useCallback(() => {
        setIsOpenFormDialog(false);
    }, []);

    const handleBatchDialog = () => {
        setIsOpenBatchDialog(true);
    }

    const handleCloseBatchDialog = useCallback(() => {
        setIsOpenBatchDialog(false);
    }, []);

    const handleUnsubscribeDialog = () => {
        setIsOpenUnsubscribeDialog(true);
    }

    const handleCloseUnsubscribeDialog = useCallback(() => {
        setIsOpenUnsubscribeDialog(false);
    }, []);

    const setGpsDevecisToload = () => {
        setStateGps({ gpsBatchValidations: {} });
    }

    const menuOptions = useMemo(() => [
        // {
        //     label: t("devices:manual_load"),
        //     icon: formSVG,
        //     action: handleFormDialog
        // },
        // {
        //     label: t("devices:upload_file"),
        //     icon: excelSVG,
        //     action: handleBatchDialog
        // },
        // ,
        {
            label: t("Baja masiva"),
            icon: unsubscribeSVG,
            action: handleUnsubscribeDialog
        }
    ], [t]);

    useEffect(() => {
        if (submitSuccess) {
            handleCloseFormDialog();
            handleCloseBatchDialog();
            handleCloseUnsubscribeDialog();
        }

        return () => {
            clearValidatedGpsDevices();
            cleanUnsubscribe();
        }
    }, [submitSuccess, handleCloseFormDialog, handleCloseBatchDialog]);

    useEffect(() => {
        if (unsubscribeSuccess) {
            handleCloseUnsubscribeDialog();
            cleanUnsubscribe();
        }
    }, [unsubscribeSuccess, handleCloseUnsubscribeDialog, cleanUnsubscribe]);

    useEffect(() => {
        if(errors.length) setShowErrors(true);
        else setShowErrors(false);
    },[errors]);

    return (
        <div>
            <ButtonMenu className={className} buttonClassName={buttonClassName} titleButton={'Baja masiva'} options={menuOptions} onDirectClick={handleUnsubscribeDialog} />
            {
                isOpenFormDialog &&
                <FormGps
                    open={isOpenFormDialog}
                    onClose={handleCloseFormDialog}
                />
            }
            {
                isOpenBatchDialog &&
                <CreateByBatch
                    title={t("devices:upload_gps")}
                    subTitle={t("devices:upload_with_excel_file")}
                    open={isOpenBatchDialog}
                    onClose={handleCloseBatchDialog}
                    submitAction={submitGpsBatchRequest}
                    submitValidateBatchAction={submitGpsDevicesValidateBatchRequest}
                    submitFetching={submitFetching}
                    submitValidateBatchFetching={submitValidateBatchFetching}
                    submitValidateBatchSuccess={submitValidateBatchSuccess}
                    showItemToLoad={showGpsDevicesToLoad}
                    onChangeFile={setGpsDevecisToload}
                    onCancelAfterValidate={setGpsDevecisToload}
                    itemsToLoadAfterValidating={
                        <ListGpsDevicesToUpload
                            itemsAvailableToInsert={gpsBatchValidations.available_to_insert}
                            itemsUnavailableToInsert={gpsBatchValidations.unavailable_to_insert}
                        />
                    }
                    type="gps"
                />
            }
            {
                isOpenUnsubscribeDialog &&
                    <UnsubscribeByBatch
                        title={t("Baja masiva")}
                        subTitle={t("devices:upload_with_excel_file")}
                        open={isOpenUnsubscribeDialog}
                        onClose={handleCloseUnsubscribeDialog}
                        submitAction={unsubscribeRequest}
                        submitFetching={unsubscribeFetching}
                        type="deregister"
                        errors={errors}
                        onChangeFile={() => setShowErrors(!showErrors)}
                        showItemToLoad={showErrors}
                        itemsToLoadAfterValidating={
                            <ListGpsDevicesToUpload
                                unsubscribe={true}
                                itemsUnavailableToInsert={errors}
                            />
                        }
                    />
            }

        </div>
    );
}

export default memo(CreateGps);